import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";

const Form = ({ handleSubmit, selected, isFlipped }) => {
  const [value, setValue] = useState(() => {
    if (selected !== undefined) {
      return selected;
    }
  });

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleFormSubmit = (e, value) => {
    e.preventDefault();
    handleSubmit(e, value);
  };

  return (
    <form onSubmit={(e) => handleFormSubmit(e, value)}>
      <FormControl component="fieldset" sx={{ marginBottom: "1rem" }}>
        <RadioGroup
          aria-label="svarsalternativ"
          name="answer-options"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel
            value="kommun"
            control={<Radio />}
            label="Kommun"
            disabled={isFlipped ? true : false}
          />
          <FormControlLabel
            value="region"
            control={<Radio />}
            label="Region"
            disabled={isFlipped ? true : false}
          />
          <FormControlLabel
            value="staten"
            control={<Radio />}
            label="Staten"
            disabled={isFlipped ? true : false}
          />
        </RadioGroup>
      </FormControl>
      {value && (
        <button type="submit" className="active_button">
          Svara
        </button>
      )}
    </form>
  );
};

export default Form;
